import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight, Clock, Star, ThumbsUp, Users } from 'lucide-react';

const ReviewAssets = () => {
  return (
    <div className="min-h-screen bg-[#f8f9fa] flex flex-col">
      <Navbar />
      
      <div className="flex-1 pt-24 px-4 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          {/* Coming Soon Badge */}
          <div className="inline-flex items-center gap-2 bg-[#0a2540]/5 text-[#0a2540] px-4 py-2 rounded-full text-sm font-medium mb-8">
            <Clock className="w-4 h-4" />
            Coming Soon
          </div>

          {/* Hero */}
          <h1 className="text-4xl md:text-5xl font-bold text-[#0a2540] tracking-tight mb-6">
            ReviewAssets
          </h1>
          <p className="text-xl text-slate-600 mb-8 max-w-xl mx-auto">
            Remove hesitation before decisions. Turn happy customers into powerful 
            social proof that closes more jobs.
          </p>

          {/* Features Preview */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <div className="w-12 h-12 bg-[#d4af37]/10 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <Star className="w-6 h-6 text-[#d4af37]" />
              </div>
              <h3 className="font-semibold text-[#0a2540] mb-2">Review Collection</h3>
              <p className="text-sm text-slate-600">
                Easy ways to request and collect customer reviews
              </p>
            </div>
            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <div className="w-12 h-12 bg-[#d4af37]/10 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <ThumbsUp className="w-6 h-6 text-[#d4af37]" />
              </div>
              <h3 className="font-semibold text-[#0a2540] mb-2">Visual Testimonials</h3>
              <p className="text-sm text-slate-600">
                Turn text reviews into shareable image assets
              </p>
            </div>
            <div className="bg-white rounded-2xl p-6 border border-slate-100">
              <div className="w-12 h-12 bg-[#d4af37]/10 rounded-xl flex items-center justify-center mb-4 mx-auto">
                <Users className="w-6 h-6 text-[#d4af37]" />
              </div>
              <h3 className="font-semibold text-[#0a2540] mb-2">Build Trust</h3>
              <p className="text-sm text-slate-600">
                Show proof that helps new customers say yes
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-[#0a2540] rounded-2xl p-8 text-white">
            <p className="text-lg mb-4">
              Homeowners hesitate. Reviews remove that hesitation.
            </p>
            <p className="text-slate-400 mb-6">
              ReviewAssets makes collecting and sharing social proof effortless.
            </p>
            <Link to="/signup">
              <Button className="bg-[#d4af37] text-[#0a2540] font-bold hover:bg-[#c5a028] h-12 px-6">
                Start with SalesAssets first
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ReviewAssets;
